import { render, staticRenderFns } from "./TurathTraining.vue?vue&type=template&id=0320e1f8&scoped=true"
import script from "./TurathTraining.vue?vue&type=script&lang=js"
export * from "./TurathTraining.vue?vue&type=script&lang=js"
import style0 from "./TurathTraining.vue?vue&type=style&index=0&id=0320e1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320e1f8",
  null
  
)

export default component.exports